import { render, staticRenderFns } from "./whatsappComponent.vue?vue&type=template&id=14b4272f&scoped=true"
import script from "./whatsappComponent.vue?vue&type=script&lang=js"
export * from "./whatsappComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b4272f",
  null
  
)

export default component.exports